window.slate = window.slate || {};
window.theme = window.theme || {};

/*================ Slate ================*/
/**
 * A11y Helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions that help make your theme more accessible
 * to users with visual impairments.
 *
 *
 * @namespace a11y
 */

slate.a11y = {

  /**
   * For use when focus shifts to a container rather than a link
   * eg for In-page links, after scroll, focus shifts to content area so that
   * next `tab` is where user expects if focusing a link, just $link.focus();
   *
   * @param {JQuery} $element - The element to be acted upon
   */
  pageLinkFocus: function($element) {
    var focusClass = 'js-focus-hidden';

    $element.first()
      .attr('tabIndex', '-1')
      .focus()
      .addClass(focusClass)
      .one('blur', callback);

    function callback() {
      $element.first()
        .removeClass(focusClass)
        .removeAttr('tabindex');
    }
  },

  /**
   * If there's a hash in the url, focus the appropriate element
   */
  focusHash: function() {
    var hash = window.location.hash;

    // is there a hash in the url? is it an element on the page?
    if (hash && document.getElementById(hash.slice(1))) {
      this.pageLinkFocus($(hash));
    }
  },

  /**
   * When an in-page (url w/hash) link is clicked, focus the appropriate element
   */
  bindInPageLinks: function() {
    $('a[href*=#]').on('click', function(evt) {
      this.pageLinkFocus($(evt.currentTarget.hash));
    }.bind(this));
  },

  /**
   * Traps the focus in a particular container
   *
   * @param {object} options - Options to be used
   * @param {jQuery} options.$container - Container to trap focus within
   * @param {jQuery} options.$elementToFocus - Element to be focused when focus leaves container
   * @param {string} options.namespace - Namespace used for new focus event handler
   */
  trapFocus: function(options) {
    var eventName = options.namespace
      ? 'focusin.' + options.namespace
      : 'focusin';

    if (!options.$elementToFocus) {
      options.$elementToFocus = options.$container;
    }

    options.$container.attr('tabindex', '-1');
    options.$elementToFocus.focus();

    $(document).on(eventName, function(evt) {
      if (options.$container[0] !== evt.target && !options.$container.has(evt.target).length) {
        options.$container.focus();
      }
    });
  },

  /**
   * Removes the trap of focus in a particular container
   *
   * @param {object} options - Options to be used
   * @param {jQuery} options.$container - Container to trap focus within
   * @param {string} options.namespace - Namespace used for new focus event handler
   */
  removeTrapFocus: function(options) {
    var eventName = options.namespace
      ? 'focusin.' + options.namespace
      : 'focusin';

    if (options.$container && options.$container.length) {
      options.$container.removeAttr('tabindex');
    }

    $(document).off(eventName);
  }
};

/**
 * Cart Template Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Cart template.
 *
 * @namespace cart
 */

slate.cart = {
  
  /**
   * Browser cookies are required to use the cart. This function checks if
   * cookies are enabled in the browser.
   */
  cookiesEnabled: function() {
    var cookieEnabled = navigator.cookieEnabled;

    if (!cookieEnabled){
      document.cookie = 'testcookie';
      cookieEnabled = (document.cookie.indexOf('testcookie') !== -1);
    }
    return cookieEnabled;
  }
};

/**
 * Utility helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions for dealing with arrays and objects
 *
 * @namespace utils
 */

slate.utils = {

  /**
   * Return an object from an array of objects that matches the provided key and value
   *
   * @param {array} array - Array of objects
   * @param {string} key - Key to match the value against
   * @param {string} value - Value to get match of
   */
  findInstance: function(array, key, value) {
    for (var i = 0; i < array.length; i++) {
      if (array[i][key] === value) {
        return array[i];
      }
    }
  },

  /**
   * Remove an object from an array of objects by matching the provided key and value
   *
   * @param {array} array - Array of objects
   * @param {string} key - Key to match the value against
   * @param {string} value - Value to get match of
   */
  removeInstance: function(array, key, value) {
    var i = array.length;
    while(i--) {
      if (array[i][key] === value) {
        array.splice(i, 1);
        break;
      }
    }

    return array;
  },

  /**
   * _.compact from lodash
   * Remove empty/false items from array
   * Source: https://github.com/lodash/lodash/blob/master/compact.js
   *
   * @param {array} array
   */
  compact: function(array) {
    var index = -1;
    var length = array == null ? 0 : array.length;
    var resIndex = 0;
    var result = [];

    while (++index < length) {
      var value = array[index];
      if (value) {
        result[resIndex++] = value;
      }
    }
    return result;
  },

  /**
   * _.defaultTo from lodash
   * Checks `value` to determine whether a default value should be returned in
   * its place. The `defaultValue` is returned if `value` is `NaN`, `null`,
   * or `undefined`.
   * Source: https://github.com/lodash/lodash/blob/master/defaultTo.js
   *
   * @param {*} value - Value to check
   * @param {*} defaultValue - Default value
   * @returns {*} - Returns the resolved value
   */
  defaultTo: function(value, defaultValue) {
    return (value == null || value !== value) ? defaultValue : value
  }
};

/**
 * Rich Text Editor
 * -----------------------------------------------------------------------------
 * Wrap iframes and tables in div tags to force responsive/scrollable layout.
 *
 * @namespace rte
 */

slate.rte = {
  /**
   * Wrap tables in a container div to make them scrollable when needed
   *
   * @param {object} options - Options to be used
   * @param {jquery} options.$tables - jquery object(s) of the table(s) to wrap
   * @param {string} options.tableWrapperClass - table wrapper class name
   */
  wrapTable: function(options) {
    var tableWrapperClass = typeof options.tableWrapperClass === "undefined" ? '' : options.tableWrapperClass;

    options.$tables.wrap('<div class="' + tableWrapperClass + '"></div>');
  },

  /**
   * Wrap iframes in a container div to make them responsive
   *
   * @param {object} options - Options to be used
   * @param {jquery} options.$iframes - jquery object(s) of the iframe(s) to wrap
   * @param {string} options.iframeWrapperClass - class name used on the wrapping div
   */
  wrapIframe: function(options) {
    var iframeWrapperClass = typeof options.iframeWrapperClass === "undefined" ? '' : options.iframeWrapperClass;

    options.$iframes.each(function() {
      // Add wrapper to make video responsive
      $(this).wrap('<div class="' + iframeWrapperClass + '"></div>');
      
      // Re-set the src attribute on each iframe after page load
      // for Chrome's "incorrect iFrame content on 'back'" bug.
      // https://code.google.com/p/chromium/issues/detail?id=395791
      // Need to specifically target video and admin bar
      this.src = this.src;
    });
  }
};

slate.Sections = function Sections() {
  this.constructors = {};
  this.instances = [];

  $(document)
    .on('shopify:section:load', this._onSectionLoad.bind(this))
    .on('shopify:section:unload', this._onSectionUnload.bind(this))
    .on('shopify:section:select', this._onSelect.bind(this))
    .on('shopify:section:deselect', this._onDeselect.bind(this))
    .on('shopify:section:reorder', this._onReorder.bind(this))
    .on('shopify:block:select', this._onBlockSelect.bind(this))
    .on('shopify:block:deselect', this._onBlockDeselect.bind(this));
};

slate.Sections.prototype = $.extend({}, slate.Sections.prototype, {
  _createInstance: function(container, constructor) {
    var $container = $(container);
    var id = $container.attr('data-section-id');
    var type = $container.attr('data-section-type');

    constructor = constructor || this.constructors[type];

    if (typeof constructor === 'undefined') {
      return;
    }

    var instance = $.extend(new constructor(container), {
      id: id,
      type: type,
      container: container
    });

    this.instances.push(instance);
  },

  _onSectionLoad: function(evt) {
    var container = $('[data-section-id]', evt.target)[0];
    if (container) {
      this._createInstance(container);
    }
  },

  _onSectionUnload: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (!instance) {
      return;
    }

    if (typeof instance.onUnload === 'function') {
      instance.onUnload(evt);
    }

    this.instances = slate.utils.removeInstance(this.instances, 'id', evt.detail.sectionId);
  },

  _onSelect: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onSelect === 'function') {
      instance.onSelect(evt);
    }
  },

  _onDeselect: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onDeselect === 'function') {
      instance.onDeselect(evt);
    }
  },

  _onReorder: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onReorder === 'function') {
      instance.onReorder(evt);
    }
  },

  _onBlockSelect: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onBlockSelect === 'function') {
      instance.onBlockSelect(evt);
    }
  },

  _onBlockDeselect: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onBlockDeselect === 'function') {
      instance.onBlockDeselect(evt);
    }
  },

  register: function(type, constructor) {
    this.constructors[type] = constructor;

    $('[data-section-type=' + type + ']').each(function(index, container) {
      this._createInstance(container, constructor);
    }.bind(this));
  }
});

/**
 * Currency Helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions that help with currency formatting
 *
 * Current contents
 * - formatMoney - Takes an amount in cents and returns it as a formatted dollar value.
 *
 */

slate.Currency = (function () {
  var moneyFormat = '${{amount}}';

  /**
   * Format money values based on your shop currency settings
   * @param  {Number|string} cents - value in cents or dollar amount e.g. 300 cents
   * or 3.00 dollars
   * @param  {String} format - shop money_format setting
   * @return {String} value - formatted value
   */
  function formatMoney(cents, format) {
    if (typeof cents === 'string') {
      cents = cents.replace('.', '');
    }
    var value = '';
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var formatString = (format || moneyFormat);

    function formatWithDelimiters(number, precision, thousands, decimal) {
      precision = slate.utils.defaultTo(precision, 2);
      thousands = slate.utils.defaultTo(thousands, ',');
      decimal = slate.utils.defaultTo(decimal, '.');

      if (isNaN(number) || number == null) {
        return 0;
      }

      number = (number / 100.0).toFixed(precision);

      var parts = number.split('.');
      var dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      var centsAmount = parts[1] ? (decimal + parts[1]) : '';

      return dollarsAmount + centsAmount;
    }

    switch (formatString.match(placeholderRegex)[1]) {
      case 'amount':
        value = formatWithDelimiters(cents, 2);
        break;
      case 'amount_no_decimals':
        value = formatWithDelimiters(cents, 0);
        break;
      case 'amount_with_comma_separator':
        value = formatWithDelimiters(cents, 2, '.', ',');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = formatWithDelimiters(cents, 0, '.', ',');
        break;
    }

    return formatString.replace(placeholderRegex, value);
  }

  return {
    formatMoney: formatMoney
  };
})();

/**
 * Image Helper Functions
 * -----------------------------------------------------------------------------
 * A collection of functions that help with basic image operations.
 *
 */

slate.Image = (function() {

  /**
   * Preloads an image in memory and uses the browsers cache to store it until needed.
   *
   * @param {Array} images - A list of image urls
   * @param {String} size - A shopify image size attribute
   */

  function preload(images, size) {
    if (typeof images === 'string') {
      images = [images];
    }

    for (var i = 0; i < images.length; i++) {
      var image = images[i];
      this.loadImage(this.getSizedImageUrl(image, size));
    }
  }

  /**
   * Loads and caches an image in the browsers cache.
   * @param {string} path - An image url
   */
  function loadImage(path) {
    new Image().src = path;
  }

  /**
   * Find the Shopify image attribute size
   *
   * @param {string} src
   * @returns {null}
   */
  function imageSize(src) {
    var match = src.match(/.+_((?:pico|icon|thumb|small|compact|medium|large|grande)|\d{1,4}x\d{0,4}|x\d{1,4})[_\.@]/);

    if (match) {
      return match[1];
    } else {
      return null;
    }
  }

  /**
   * Adds a Shopify size attribute to a URL
   *
   * @param src
   * @param size
   * @returns {*}
   */
  function getSizedImageUrl(src, size) {
    if (size === null) {
      return src;
    }

    if (size === 'master') {
      return this.removeProtocol(src);
    }

    var match = src.match(/\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif)(\?v=\d+)?$/i);

    if (match) {
      var prefix = src.split(match[0]);
      var suffix = match[0];

      return this.removeProtocol(prefix[0] + '_' + size + suffix);
    } else {
      return null;
    }
  }

  function removeProtocol(path) {
    return path.replace(/http(s)?:/, '');
  }

  return {
    preload: preload,
    loadImage: loadImage,
    imageSize: imageSize,
    getSizedImageUrl: getSizedImageUrl,
    removeProtocol: removeProtocol
  };
})();

/**
 * Variant Selection scripts
 * ------------------------------------------------------------------------------
 *
 * Handles change events from the variant inputs in any `cart/add` forms that may
 * exist. Also updates the master select and triggers updates when the variants
 * price or image changes.
 *
 * @namespace variants
 */

slate.Variants = (function() {

  /**
   * Variant constructor
   *
   * @param {object} options - Settings from `product.js`
   */
  function Variants(options) {
    this.$container = options.$container;
    this.product = options.product;
    this.singleOptionSelector = options.singleOptionSelector;
    this.originalSelectorId = options.originalSelectorId;
    this.enableHistoryState = options.enableHistoryState;
    this.currentVariant = this._getVariantFromOptions();

    $(this.singleOptionSelector, this.$container).on('change', this._onSelectChange.bind(this));
  }

  Variants.prototype = $.extend({}, Variants.prototype, {

    /**
     * Get the currently selected options from add-to-cart form. Works with all
     * form input elements.
     *
     * @return {array} options - Values of currently selected variants
     */
    _getCurrentOptions: function() {
      var currentOptions = $.map($(this.singleOptionSelector, this.$container), function(element) {
      
        var $element = $(element);
        var type = $element.attr('type');
        var currentOption = {};

        if (type === 'radio' || type === 'checkbox') {
          if ($element[0].checked) {
            currentOption.value = $element.val();
            currentOption.index = $element.data('index');

            return currentOption;
          } else {

            return false;
          }
        } else {
          currentOption.value = $element.val();
          currentOption.index = $element.data('index');

          return currentOption;
        }
      });

      // remove any unchecked input values if using radio buttons or checkboxes
      currentOptions = slate.utils.compact(currentOptions);

      return currentOptions;
    },

    /**
     * Find variant based on selected values.
     *
     * @param  {array} selectedValues - Values of variant inputs
     * @return {object || undefined} found - Variant object from product.variants
     */
    _getVariantFromOptions: function() {
      var selectedValues = this._getCurrentOptions();
      var variants = this.product.variants;
      var found = false;

      variants.forEach(function(variant) {
        var satisfied = true;

        selectedValues.forEach(function(option) {
          if (satisfied) {
            satisfied = (option.value === variant[option.index]);
          }
        });

        if (satisfied) {
          found = variant;
        }
      });

      return found || null;
    },

    /**
     * Event handler for when a variant input changes.
     */
    _onSelectChange: function() {
      var variant = this._getVariantFromOptions();

      this.$container.trigger({
        type: 'variantChange',
        variant: variant
      });

      if (!variant) {
        return;
      }

      // BEGIN SWATCHES
      // var selector = this.originalSelectorId;
      // if (variant) {
      //     var form = $(selector).closest('form');
      //     for (var i=0,length=variant.options.length; i<length; i++) {
      //         var radioButton = form.find('.swatch[data-index="' + i + '"] :radio[value="' + variant.options[i] +'"]');
      //         if (radioButton.size()) {
      //             radioButton.get(0).checked = true;
      //         }
      //     }
      // }
      // END SWATCHES

      this._updateMasterSelect(variant);
      this._updateImages(variant);
      this._updatePrice(variant);
      this.currentVariant = variant;

      if (this.enableHistoryState) {
        this._updateHistoryState(variant);
      }
    },

    /**
     * Trigger event when variant image changes
     *
     * @param  {object} variant - Currently selected variant
     * @return {event}  variantImageChange
     */
    _updateImages: function(variant) {
      var variantImage = variant.featured_image || {};
      var currentVariantImage = this.currentVariant.featured_image || {};

      if (!variant.featured_image || variantImage.src === currentVariantImage.src) {
        return;
      }

      this.$container.trigger({
        type: 'variantImageChange',
        variant: variant
      });
    },

    /**
     * Trigger event when variant price changes.
     *
     * @param  {object} variant - Currently selected variant
     * @return {event} variantPriceChange
     */
    _updatePrice: function(variant) {
      if (variant.price === this.currentVariant.price && variant.compare_at_price === this.currentVariant.compare_at_price) {
        return;
      }

      this.$container.trigger({
        type: 'variantPriceChange',
        variant: variant
      });
    },

    /**
     * Update history state for product deeplinking
     *
     * @param {object} variant - Currently selected variant
     */
    _updateHistoryState: function(variant) {
      if (!history.replaceState || !variant) {
        return;
      }

      var newurl = window.location.protocol + '//' + window.location.host + window.location.pathname + '?variant=' + variant.id;
      window.history.replaceState({path: newurl}, '', newurl);
    },

    /**
     * Update hidden master select of variant change
     *
     * @param {object} variant - Currently selected variant
     */
    _updateMasterSelect: function(variant) {
      $(this.originalSelectorId, this.$container)[0].value = variant.id;
    }
  });

  return Variants;
})();


/*================ Sections ================*/
/**
 * Product Template Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Product template.
 *
   * @namespace product
 */

theme.Product = (function() {

  var selectors = {
    addToCart: '[data-add-to-cart]',
    addToCartText: '[data-add-to-cart-text]',
    comparePrice: '[data-compare-price]',
    comparePriceText: '[data-compare-text]',
    originalSelectorId: '[data-product-select]',
    priceWrapper: '[data-price-wrapper]',
    productFeaturedImage: '[data-product-featured-image]',
    productJson: '[data-product-json]',
    productPrice: '[data-product-price]',
    productForm: '[data-product-form]',
    productThumbs: '[data-product-single-thumbnail]',
    singleOptionSelector: 'input[type="radio"]',
    productGallery: '[data-product-gallery]',
    productAccordion: '[data-product-accordion]',
    productAlert: '[data-alert]',
    productTabs: '[data-product-tabs]',
    videoPlay: '[data-video-play]',
    productSuccess: '[data-product-add-successful]'
  };

  /**
   * Product section constructor. Runs on page load as well as Theme Editor
   * `section:load` events.
   * @param {string} container - selector for the section container DOM element
   */
  function Product(container) {
    this.$container = $(container);

    // Stop parsing if we don't have the product json script tag when loading
    // section in the Theme Editor
    if (!$(selectors.productJson, this.$container).html()) {
      return;
    }

    var sectionId = this.$container.attr('data-section-id');
    this.productSingleObject = JSON.parse($(selectors.productJson, this.$container).html());

    var options = {
      $container: this.$container,
      enableHistoryState: this.$container.data('enable-history-state') || false,
      singleOptionSelector: selectors.singleOptionSelector,
      originalSelectorId: selectors.originalSelectorId,
      product: this.productSingleObject
    };

    this.settings = {};
    this.namespace = '.product';
    this.variants = new slate.Variants(options);
    this.$featuredImage = $(selectors.productFeaturedImage, this.$container);
    this.$productGallery = $(selectors.productGallery, this.$container);
    this.$productThumbnails = $(selectors.productThumbs, this.$container);
    this.$productAccordion = $(selectors.productAccordion, this.$container);
    this.$productAlert = $(selectors.productAlert, this.$container);
    this.$productTabs = $(selectors.productTabs, this.$container);
    this.$videoPlay = $(selectors.videoPlay, this.$container);
    this.$productSuccess = $(selectors.productSuccess, this.$container);
    this.$productSelect = $(selectors.originalSelectorId, this.$container);
    this.$productForm = $(selectors.productForm, this.$container);

    this.$container.on('variantChange' + this.namespace, this.updateAddToCartState.bind(this));
    this.$container.on('variantPriceChange' + this.namespace, this.updateProductPrices.bind(this));

    if (this.$featuredImage.length > 0) {
      this.settings.imageSize = slate.Image.imageSize(this.$featuredImage.attr('src'));
      slate.Image.preload(this.productSingleObject.images, this.settings.imageSize);

      this.$container.on('variantImageChange' + this.namespace, this.updateProductImage.bind(this));
    }

    if( this.$productGallery.length > 0 ){
      this.initiateProductGallery();
    }

    if( this.$productAccordion.length > 0 ){
      this.initiateProductAccordion();
    }

    if( this.$productTabs.length > 0 ){
      this.initiateProductTabs();
    }

    if( this.$productAlert.length > 0 && this.$productAlert.data('countdown') ){
        this.initiateCountdown();
    }

    if( this.$productSuccess.length > 0 ){

      var self = this;

      // Cart JS Event
      $(document).on('cart.requestComplete', function(event, cart) {
        
        var items = cart.items;

        for( var i = 0; i < items.length; i++ ){

          var line_item = items[i];
          
          if( line_item.id == self.$productSelect.val() ){
            
            self.$productSuccess.addClass('is--visible');

            setTimeout(function(){
              self.$productSuccess.removeClass('is--visible');
            }, 5000);
          }
        }
      });
    }

    if( this.$videoPlay.length > 0 ){

      this.$videoPlay.on('click', function () {
        
        var $this = $(this),
            $video = $this.prev('video')[0];

        if($video.paused){
          $video.play();
          $this.addClass('is--playing');
        }else{
          $video.pause();
          $this.removeClass('is--playing');
        }
      });
    }
  }

  Product.prototype = $.extend({}, Product.prototype, {

    /**
     * Updates the DOM state of the add to cart button
     *
     * @param {boolean} enabled - Decides whether cart is enabled or disabled
     * @param {string} text - Updates the text notification content of the cart
     */
    updateAddToCartState: function(evt) {
      var variant = evt.variant;

      if (variant) {
        $(selectors.priceWrapper, this.$container).removeClass('hide');
      } else {
        $(selectors.addToCart, this.$container).prop('disabled', true);
        $(selectors.addToCartText, this.$container).html(theme.strings.unavailable);
        $(selectors.priceWrapper, this.$container).addClass('hide');
        return;
      }

      if (variant.available) {
        $(selectors.addToCart, this.$container).prop('disabled', false);
        $(selectors.addToCartText, this.$container).html(theme.strings.addToCart + ' <i class="fal fa-shopping-bag"></i>');
      } else {
        $(selectors.addToCart, this.$container).prop('disabled', true);
        $(selectors.addToCartText, this.$container).html(theme.strings.soldOut);
      }
    },

    /**
     * Updates the DOM with specified prices
     *
     * @param {string} productPrice - The current price of the product
     * @param {string} comparePrice - The original price of the product
     */
    updateProductPrices: function(evt) {
      var variant = evt.variant;
      var $comparePrice = $(selectors.comparePrice, this.$container);
      var $compareEls = $comparePrice.add(selectors.comparePriceText, this.$container);

      $(selectors.productPrice, this.$container)
        .html(slate.Currency.formatMoney(variant.price, theme.moneyFormat));

      if (variant.compare_at_price > variant.price) {
        $comparePrice.html(slate.Currency.formatMoney(variant.compare_at_price, theme.moneyFormat));
        $compareEls.removeClass('hide');
      } else {
        $comparePrice.html('');
        $compareEls.addClass('hide');
      }
    },

    /**
     * Updates the DOM with the specified image URL
     *
     * @param {string} src - Image src URL
     */
    updateProductImage: function(evt) {
      var variant = evt.variant;
      var sizedImgUrl = slate.Image.getSizedImageUrl(variant.featured_image.src, this.settings.imageSize);

      this.$featuredImage.attr('src', sizedImgUrl);
    },

    initiateProductGallery: function () {
      
      // Set this here to avoid scope confusion
      var _this = this;

      // On initialize loop through thumbnails
      _this.$productGallery.on('init', function (slick) {

        _this.$productThumbnails.each(function () {

          var $this = $(this);

          // Add event listener to thumbnails
          $this.on('click', function (e) {
            // prevent the link working
            e.preventDefault();
            // Go to the correct slide
            _this.$productGallery.slick('slickGoTo', $(this).data('slide') );
          });
        });
      });

      _this.$productGallery.slick({
        infinite: false,
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: true,
        fade: false,
        slide: '.gallery__slide',
        adaptiveHeight: true
      });
    },

    initiateProductAccordion: function () {
      
      // Set this here to avoid scope confusion
      var _this = this;
        
      this.$productAccordion.accordion({
        collapsible: true,
        active: false,
        heightStyle: "content"
      });
    },

    createTimeToday: function () {

      var _this = this;

      var dateObject  = new Date();
          year        = dateObject.getFullYear()
          month       = dateObject.getMonth(),
          day         = dateObject.getDate();

      var timeArr = _this.$productAlert.data('countdown-time').toString().split(":");

      return new Date(year, month, day, timeArr[0], timeArr[1], timeArr[2]);
    },

    createFutureTime: function () {

      var _this = this;

      var dateObject  = _this.$productAlert.data('countdown-day').toString().split("/");
          year        = parseInt(dateObject[2])
          month       = parseInt(dateObject[1]) -1,
          day         = parseInt(dateObject[0]);

      var timeArr = _this.$productAlert.data('countdown-time').toString().split(":");

      return new Date(year, month, day, timeArr[0], timeArr[1], timeArr[2]);
    },

    initiateCountdown: function () {
      
      // Set this here to avoid scope confusion
      var _this = this;

      var $countdown = $('[data-countdown]', _this.$productAlert);

      var data = {
        restart         : _this.$productAlert.data('restart'),
        availability    : _this.$productAlert.data('availability'),
        showDays        : _this.$productAlert.data('show-days'),
        countdown       : _this.$productAlert.data('countdown'),
        countdownTime   : _this.$productAlert.data('countdown-time'),
        countdownDay    : _this.$productAlert.data('countdown-day')
      }

      // Store global variable within this function
      var countdownDate;

      if( !data.countdownDay || typeof data.countdownDay === 'undefined' ){
        countdownDate = _this.createTimeToday();
      }else{
        countdownDate = _this.createFutureTime();
      }

      // Store some variables here for use later
      // var countdownDate           = _this.createTimeToday();
      var countdownDeadline       = countdownDate.getTime();
      var countdownDay            = countdownDate.getDay();
      var countdownDayAfter       = countdownDay + 1;
      var availability            = data.availability;

      var x = setInterval(function() {

        // Set the current time and day now so we can check later
        var now   = new Date().getTime(),
            today = new Date().getDay();

        // If we do not want the countdown to show today, hide it
        if( !availability.includes(today) ){
          _this.$productAlert.hide(0);
          return;
        }

        // Set the time now so we can check below
        var time = countdownDeadline - now;

        // If the time has already past, do below.
        if ( time <= 0 ) {

          /*
          * If we want the countdown to restart, change the countdown deadline for tomorrow.
          * This check is useful if we want the countdown to count down to a particular time
          * but we don't want it to start counting down right away.
          */
          if( data.restart === "true" && availability.includes(countdownDayAfter) ){

            countdownDate.setDate( new Date().getDate() + 1 );
            countdownDeadline = countdownDate.getTime();

            // Set the time for tomorrow
            time = countdownDeadline - now;

          }else{

            _this.$productAlert.hide(0);
            
            // Return so we don't get -22h -59m -59s
            return;
          }
        }

        var days          = Math.floor(time / (1000 * 60 * 60 * 24)),
            hours         = Math.floor((time % (1000 * 60 * 60 * 24))/(1000 * 60 * 60)),
            minutes       = Math.floor((time % (1000 * 60 * 60)) / (1000 * 60)),
            seconds       = Math.floor((time % (1000 * 60)) / 1000),
            timeString    = "";

        // If we want the days to show, show them.
        if( data.showDays ){
          timeString +=  days + "d ";
        }

        $countdown.text( timeString + hours + "h " + minutes + "m " + seconds + "s" );

      }, 1000);
    },

    initiateProductTabs: function (){

      this.$productTabs.tabs();
    },

    /**
     * Event callback for Theme Editor `section:unload` event
     */
    onUnload: function() {
      this.$container.off(this.namespace);
    }
  });

  return Product;
})();

/**
 * Colelction Template Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the collection template.
 *
   * @namespace collection
 */

theme.Collection = (function() {

  var selectors = {
    ajaxPagination: '[data-pagination]',
    ajaxPaginationType: '[data-pagination-type]',
    ajaxPaginationLoop: '[data-pagination-loop]',
    ajaxPaginationContainer: '[data-pagination-container]',
    collectionJson: '[data-collection-json]'
  };

  /**
   * Collection section constructor. Runs on page load as well as Theme Editor
   * `section:load` events.
   * @param {string} container - selector for the section container DOM element
   */
  function Collection(container) {
    this.$container = $(container);

    var self = this;

    // Stop parsing if we don't have the product json script tag when loading
    // section in the Theme Editor
    if (!$(selectors.collectionJson, this.$container).html()) {
      return;
    }

    var sectionId = this.$container.attr('data-section-id');

    var options = {
      $container: this.$container,
      enableHistoryState: this.$container.data('enable-history-state') || false,
      ajaxPagination: this.$container.data('pagination') || false,
      ajaxPaginationType: this.$container.data('pagination-type'),
      ajaxPaginationLoop: this.$container.data('pagination-loop'),
      ajaxPaginationContainer: this.$container.data('pagination-container'),
      useFilters: this.$container.data('use-filters')
    };

    this.cache = {
      $changeView: $('.change-view', this.$container),
      $collectionFilters: $('#collectionFilters', this.$container),
      $filterTrigger: $('#filterTrigger', this.$container),
      $collectionLoop: $('.collection-loop', this.$container)
    }

    this.settings = {};

    this.namespace = '.collection';

    this.useAjaxPagination(options);

    if( this.cache.$changeView.length > 0 ){
      this.changeView();
    }

    if( this.cache.$filterTrigger.length > 0 ){
      this.cache.$filterTrigger.on('click', function () {
        self.cache.$collectionFilters.toggleClass('d-block');
      });
    }
  }

  Collection.prototype = $.extend({}, Collection.prototype, {

    changeView: function () {

      var _this = this;

      _this.cache.$changeView.on('click', function (){

        var $this       = $(this),
            view        = $this.data('view'),
            viewport    = $this.data('viewport');

          _this.cache.$collectionLoop.attr('data-columns-'+viewport, view);
          _this.cache.$changeView.removeClass('is--active');

          $this.addClass('is--active');
      });

    },

    /**
     * Function to use Ajax Pagination
     */
    useAjaxPagination: function (options) {
        if( options.ajaxPagination ){
            console.log('collection JS running');
            var endlessScroll = new Ajaxinate({
                container: options.ajaxPaginationLoop,
                pagination: options.ajaxPaginationContainer,
                method: options.ajaxPaginationType
            });
        }
    },

    /**
     * Event callback for Theme Editor `section:unload` event
     */
    onUnload: function() {
      this.$container.off(this.namespace);
    }
  });

  return Collection;
})();


/*================ Templates ================*/
/**
 * Customer Addresses Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Customer Addresses
 * template.
 *
 * @namespace customerAddresses
 */

theme.customerAddresses = (function() {
  var $newAddressForm = $('#AddressNewForm');

  if (!$newAddressForm.length) {
    return;
  }

  // Initialize observers on address selectors, defined in shopify_common.js
  if (Shopify) {
    new Shopify.CountryProvinceSelector('AddressCountryNew', 'AddressProvinceNew', {
      hideElement: 'AddressProvinceContainerNew'
    });
  }

  // Initialize each edit form's country/province selector
  $('.address-country-option').each(function() {
    var formId = $(this).data('form-id');
    var countrySelector = 'AddressCountry_' + formId;
    var provinceSelector = 'AddressProvince_' + formId;
    var containerSelector = 'AddressProvinceContainer_' + formId;

    new Shopify.CountryProvinceSelector(countrySelector, provinceSelector, {
      hideElement: containerSelector
    });
  });

  // Toggle new/edit address forms
  $('.address-new-toggle').on('click', function() {
    $newAddressForm.toggleClass('hide');
  });

  $('.address-edit-toggle').on('click', function() {
    var formId = $(this).data('form-id');
    $('#EditAddress_' + formId).toggleClass('hide');
  });

  $('.address-delete').on('click', function() {
    var $el = $(this);
    var formId = $el.data('form-id');
    var confirmMessage = $el.data('confirm-message');
    if (confirm(confirmMessage || 'Are you sure you wish to delete this address?')) {
      Shopify.postLink('/account/addresses/' + formId, {parameters: {_method: 'delete'}});
    }
  });
})();

/**
 * Password Template Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Password template.
 *
 * @namespace password
 */

theme.customerLogin = (function() {
  var config = {
    recoverPasswordForm: '#RecoverPassword',
    hideRecoverPasswordLink: '#HideRecoverPasswordLink'
  };

  if (!$(config.recoverPasswordForm).length) {
    return;
  }

  checkUrlHash();
  resetPasswordSuccess();

  $(config.recoverPasswordForm).on('click', onShowHidePasswordForm);
  $(config.hideRecoverPasswordLink).on('click', onShowHidePasswordForm);

  function onShowHidePasswordForm(evt) {
    evt.preventDefault();
    toggleRecoverPasswordForm();
  }

  function checkUrlHash() {
    var hash = window.location.hash;

    // Allow deep linking to recover password form
    if (hash === '#recover') {
      toggleRecoverPasswordForm();
    }
  }

  /**
   *  Show/Hide recover password form
   */
  function toggleRecoverPasswordForm() {
    $('#RecoverPasswordForm').toggleClass('hide');
    $('#CustomerLoginForm').toggleClass('hide');
  }

  /**
   *  Show reset password success message
   */
  function resetPasswordSuccess() {
    var $formState = $('.reset-password-success');

    // check if reset password form was successfully submited.
    if (!$formState.length) {
      return;
    }

    // show success message
    $('#ResetSuccess').removeClass('hide');
  }
})();


/*================ Theme ================*/
;(function (root, factory) {

    if (typeof define === 'function' && define.amd) {
        define(factory);
    } else if (typeof exports === 'object') {
        module.exports = factory();
    } else {
        root.Header = factory();
    }
  
  }(this, function () {

    var Header = Header || {};

    // Cache the jQuery objects for efficiency 
    Header.cache = {
        headerPrimary: document.getElementById('headerPrimary'),
        headerSecondary: document.getElementById('headerSecondary')
    }

    // Set listeners in a private function
    var eventListeners = function () {

        if( window.theme.template == "index" ){
            window.addEventListener('scroll', function(e) {

                // Has scrolled
                if( document.documentElement.scrollTop > 100 ){

                    if( !Header.cache.headerSecondary.classList.contains('is--visible') ){
                        Header.cache.headerSecondary.classList.add('is--visible');
                    }

                // Hasn't scrolled
                }else{
                    if( Header.cache.headerSecondary.classList.contains('is--visible') ){
                        Header.cache.headerSecondary.classList.remove('is--visible');
                    }
                }

                return;
            }, false);
        }
    }

    // Initialize the app with Header.init()
    Header.init = function () {
        
        eventListeners();
    }

    // Return so this can be used.
    return Header;
}));


;(function (root, factory) {

    if (typeof define === 'function' && define.amd) {
        define(factory);
    } else if (typeof exports === 'object') {
        module.exports = factory();
    } else {
        root.Drawers = factory();
    }
  
  }(this, function () {

    var Drawers = Drawers || {};

    // Cache the jQuery objects for efficiency 
    Drawers.cache = {
        toggle:         $('.drawer-toggle')
    }

    var toggleDrawer = function (target){

        // Cache the drawer
        var $drawer = $(target);

        // Check if the drawer exists
        if( $drawer.length == 0 || $drawer == undefined ){
            return;
        }

        $drawer.toggleClass('is--open');
    };

    // Set listeners in a private function
    var eventListeners = function () {

        Drawers.cache.toggle.on('click', function (e) {

            e.preventDefault();
            toggleDrawer($(this).data('target'));
        });
    }

    Drawers.openDrawer = function (target){

        // Cache the drawer
        var $drawer = $(target);

        // Check if the drawer exists
        if( $drawer.length == 0 || $drawer == undefined ){
            return;
        }

        // If it's already open, return!
        if( $drawer.hasClass('is--open') ){
            return;
        }

        $drawer.addClass('is--open');
    }

    // Initialize the app with Drawers.init()
    Drawers.init = function () {
        
        eventListeners();
    }

    // Return so this can be used.
    return Drawers;
}));


;(function (root, factory) {

    if (typeof define === 'function' && define.amd) {
        define(factory);
    } else if (typeof exports === 'object') {
        module.exports = factory();
    } else {
        root.PredictiveSearch = factory();
    }
  
  }(this, function () {

    var PredictiveSearch = PredictiveSearch || {};

    // Cache the jQuery objects for efficiency 
    PredictiveSearch.cache = {
        Search:         $('#Search'),
        $searchTrigger: $('.search-trigger'),
        $searchForm:    $('[data-search-form]'),
        ResultsBox:     $('form[action="/search"] #resultsBox'),
        SearchEmpty:    $('#searchEmpty'),
        $searchClose:   $('#searchClose', this.$searchForm)
    }

    // Sort the data here to prevent cluttering the callback
    var sortProductResultData = function (product) {

        return obj = {
            available: product.available,
            varies: ( product.price_max > product.price_min ? true : false ),
            on_sale: ( product.compare_at_price_max > 0 ? true : false ),
            image: product.image,
            title: product.title,
            url: product.url
        };
    }

    // Loop through the data here and add to an object
    // that is passed to Handlebars object.
    var showProductResultData = function (response) {
        var productSuggestions = response.resources.results.products,
            results = {
                has_results: false,
                products: []
            };

        // If there are results, we will output them
        // in the Handlebars object
        if( productSuggestions.length > 0 ){
            results.has_results = true;
        }

        // Loop through and add to the results object.
        for ( obj in productSuggestions ){
            results.products.push(sortProductResultData( productSuggestions[obj] ));
        }

        // Set up the Handlebars Object
        var source      = document.getElementById("predictive-search-template").innerHTML,
            template    = Handlebars.compile(source),
            html        = template(results);
        
        // Empty then add the HTML
        PredictiveSearch.cache.ResultsBox.empty().html(html);
    }

    // Set listeners in a private function
    var eventListeners = function () {

        PredictiveSearch.cache.SearchEmpty.on('click', function () {
            PredictiveSearch.cache.Search.val("");
            PredictiveSearch.cache.ResultsBox.empty();
        });

        PredictiveSearch.cache.Search.keyup( function (){

            var length  = PredictiveSearch.cache.Search.val().length;

            // If the box is empty remove the last results
            if( length == 0 ){ PredictiveSearch.cache.ResultsBox.empty(); }

            // If there are less than 4 characters don't search
            if( length < 4 ){ return; }

            PredictiveSearch.searchProducts($(this).val(), 4, function (response) {
                showProductResultData( response );
            });
        });

        PredictiveSearch.cache.$searchClose.on('click', function () {

            if( PredictiveSearch.cache.$searchForm.hasClass('is--visible') ){
                PredictiveSearch.cache.$searchForm.removeClass('is--visible');
            }
        });

        PredictiveSearch.cache.$searchTrigger.on('click', function () {
            PredictiveSearch.cache.$searchForm.toggleClass('is--visible');
        });


    }

    // Make this a public function
    PredictiveSearch.searchProducts = function (term, limit, callback) {

        console.log( term );
        
        jQuery.getJSON("/search/suggest.json", {
            "q": term,
            resources: {
                "type": "product",
                "limit": limit,
                "options": {
                    "unavailable_products": "last",
                    "fields": "title,product_type,variants.title"
                }
            }
        }).done(function(response) {
            // var productSuggestions = response.resources.results.products
            
            callback(response);
        });
    }

    // Initialize the app with PredictiveSearch.init()
    PredictiveSearch.init = function () {
        
        eventListeners();
    }

    // Return so this can be used.
    return PredictiveSearch;
}));


;(function (root, factory) {

    if (typeof define === 'function' && define.amd) {
        define(factory);
    } else if (typeof exports === 'object') {
        module.exports = factory();
    } else {
        root.QuickView = factory();
    }
  
  }(this, function () {

    var QuickView = QuickView || {};

    // Cache the jQuery objects for efficiency 
    QuickView.cache = {
        remodal     : '[data-remodal-id=RemodalQuickBuy]',
        remodalObj  : $('#RemodalQuickBuy'),
        trigger     : '.quick-view-trigger'
    };

    var templateCompile = function(product){

    	var source   = document.getElementById("QuickBuyTemplate").innerHTML,
          template = Handlebars.compile(source),
          context = {
            "onSale": ( product.compare_at_price > product.price ? true : false ),
            "productTitle": product.title,
            "productPrice": Shopify.formatMoney(product.price, window.theme.moneyFormat),
            "productId": product.id,
            "productUrl": product.url,
            "productCompareAtPrice": Shopify.formatMoney(product.compare_at_price, window.theme.moneyFormat),
            "btnAddToCartText": "Add To Cart",
            "productDescription": product.description,
            "productFeaturedImageSrc": product.featured_image,
            "variants": product.variants,
            "images": product.images,
            "paymentIcons": window.theme.paymentIcons,
          };
        
          console.log( 'product.variants.length: ', product.variants.length );
          console.log( 'product.variants[0].title: ', product.variants[0].title );

        if( product.variants.length == 1 && product.variants[0].title.includes('Default') ){
            context["oneVariant"] = true;
        }

        Handlebars.registerHelper('formatMoney', function(price) {
            return Shopify.formatMoney(price, window.theme.moneyFormat);
        });

		return template(context);
    };

    var quickViewCallback = function (variant) {
      
        var addToCart     = document.querySelectorAll("[data-remodal-id=RemodalQuickBuy] #addToCart")[0],
            soldOut       = document.querySelectorAll("[data-remodal-id=RemodalQuickBuy] #soldOut")[0],
            comparePrice  = document.querySelectorAll("[data-remodal-id=RemodalQuickBuy] #comparePrice")[0];
  
        addToCart.setAttribute("data-cart-add", variant.id);
  
        // Show Sold Out alert
        if( variant.available ){
          soldOut.style.display = "none";
          addToCart.style.display = "inline-block";
        }else{
          soldOut.style.display = "block";
          addToCart.style.display = "none";
        }
  
        if ( variant.compare_at_price > variant.price ) {
          comparePrice.style.display = "block";
        } else{
          comparePrice.style.display = "none";
        }
    };

    // Set listeners in a private function
    var eventListeners = function () {

        var _this = this;

        $(document).on('click', QuickView.cache.trigger, function () {

            QuickView.triggerQuickView($(this));
        });

        $(document).on('opening', QuickView.cache.remodal, function () {

            $('.quick-view__slider').slick({
                dots: false,
                arrows: true,
                infinite: true,
                fade: false,
                cssEase: 'linear'
            });
        });
    
        $(document).on('closed', QuickView.cache.remodal, function (e) {
            
            $('.quick-view__slider').slick('unslick');
            QuickView.cache.remodalObj.innerHTML = "";
        });
    };

    QuickView.triggerQuickView = function (ele) {

        var $this = $(ele);

        var productHandle 	= $this.data('product-handle'),
        ajaxUrl 		    = '/products/' + productHandle + '.js';
    
        $.getJSON(ajaxUrl, function(product) {
        
            var remodal = $(QuickView.cache.remodal).remodal();

            QuickView.cache.remodalObj.html(templateCompile(product));

            var selectCallback = function(variant, selector) {
                quickViewCallback(variant);
            };

            new Shopify.OptionSelectors('quickViewSelector', {
                product: product,
                onVariantSelected: selectCallback,
                enableHistoryState: true
            });

            remodal.open();
        });	

    }


    // Initialize the app with QuickView.init()
    QuickView.init = function () {
        
        eventListeners();
    }

    // Return so this can be used.
    return QuickView;
}));








var _this = this;

$(document).on('click', '.quick-view-trigger', function () {

    var $this = $(this);
  
    
});
;(function (root, factory) {

    if (typeof define === 'function' && define.amd) {
        define(factory);
    } else if (typeof exports === 'object') {
        module.exports = factory();
    } else {
        root.RecentlyViewed = factory();
    }
  
  }(this, function () {

    var RecentlyViewed = RecentlyViewed || {};

    RecentlyViewed.name = 'shopify_recently_viewed';

    // Cache the jQuery objects for efficiency 
    RecentlyViewed.config = {
        expires: 90,
        path: '/',
        domain: window.location.hostname,
        howManyToStoreInMemory: 10
    }

    // Set listeners in a private function
    var eventListeners = function () {

        var _this = this;

        window.addEventListener('load', function () {

            RecentlyViewed.recordRecentlyViewed();
        });
    }

    var getProduct = function( handle, callback ) {

        var ajaxUrl = '/products/' + handle + '.js';

        $.getJSON(ajaxUrl, function(product) {
            
            var productObj = {
                "available": product.available,
                "onSale": ( product.compare_at_price > product.price ? true : false ),
                "productTitle": product.title,
                "productPrice": Shopify.formatMoney(product.price, window.theme.moneyFormat),
                "productPriceVaries": product.price_varies,
                "productId": product.id,
                "productUrl": product.url,
                "productCompareAtPrice": Shopify.formatMoney(product.compare_at_price, window.theme.moneyFormat),
                "productDescription": product.description,
                "productFeaturedImageSrc": product.featured_image
            };

            if( product.compare_at_price_max > product.price ){
                productObj["savings"] = Math.floor( ((product.compare_at_price - product.price) * 100) / product.compare_at_price );
            }

            return callback( productObj );
        });	
    }

    RecentlyViewed.showRecentlyViewed = function (options) {

        var _this = this;

        // Store some default values if none present.
        var templateId = ( typeof(options.templateId) === "undefined" ? 'RecentlyViewedTemplate' : options.templateId ),
            container = ( typeof(options.container) === "undefined" ? 'recentlyViewed' : options.container ),
            limit = ( typeof(options.limit) === "undefined" ? 4 : options.limit );

        // Cache some variables
        var cache = {
            container   : document.getElementById(container),
            templateId  : document.getElementById(templateId)
        }

        // Do a couple of checks to see if its worth still running
        if( cache.container == null || cache.container == undefined ){
            return;
        }

        if( cache.templateId == null || cache.container == undefined ){
            return;
        }

        // Get the product handles
        var recentlyViewed = _this.readCookie();
        
        console.log(recentlyViewed.length);
        if (recentlyViewed.length == 0){
            $('.recently-viewed__no-products-found').css('display', 'block');
        }

        for ( var i = 0; i < recentlyViewed.length; i++ ){

            // Reached our limit, stop proceeding
            if( i == limit ){
                return;
            }

            // Store the handle for readability
            var handle = recentlyViewed[i];

            getProduct( handle, function (product) {

                var source      = cache.templateId.innerHTML,
                    template    = Handlebars.compile(source);

                Handlebars.registerHelper('formatMoney', function(price) {
                    console.log( price );
                    return Shopify.formatMoney(price, window.theme.moneyFormat);
                });

                Handlebars.registerHelper('priceFrom', function(price) {
                    console.log( price );
                    return window.theme.strings.onSaleFrom + " " + price;
                });


                cache.container.innerHTML += template(product);
            });
        }
        
    }

    RecentlyViewed.recordRecentlyViewed = function () {

        if( window.theme.template != 'product' ){
            return;
        }

        var _this = this;

        var recentlyViewed = _this.readCookie(_this.name);

        // What is the product handle on this page.
        var productHandle = window.theme.product.handle;
        // In what position is that product in memory.
        var position = recentlyViewed.indexOf( productHandle );

        // If not in memory.
        if (position === -1) {
           // Add product at the start of the list.
           recentlyViewed.unshift(productHandle);
           // Only keep what we need.
           recentlyViewed = recentlyViewed.splice(0, _this.config.howManyToStoreInMemory);
        } else {
           // Remove the product and place it at start of list.
           recentlyViewed.splice(position, 1);
           recentlyViewed.unshift(productHandle);              
        }

        // Update cookie.
        _this.setCookie(recentlyViewed);

    }

    RecentlyViewed.setCookie = function(values) {
        
        var _this = this;

        Cookies.set(_this.name, values.join(',') );
    }

    RecentlyViewed.readCookie = function () {

        var _this = this;

        var recentlyViewed  = [],
            cookieValue     = Cookies.get(_this.name);

        if (cookieValue != null || cookieValue != undefined ) {
            recentlyViewed = cookieValue.split(',');
        }

        return recentlyViewed;    
    }

    // Initialize the app with RecentlyViewed.init()
    RecentlyViewed.init = function () {
        
        eventListeners();
    }

    // Return so this can be used.
    return RecentlyViewed;
}));



$(document).ready(function() {
  var sections = new slate.Sections();
  sections.register('product', theme.Product);
  sections.register('collection', theme.Collection);

  // Common a11y fixes
  slate.a11y.pageLinkFocus($(window.location.hash));

  $('.in-page-link').on('click', function(evt) {
    slate.a11y.pageLinkFocus($(evt.currentTarget.hash));
  });

  // Target tables to make them scrollable
  var tableSelectors = '.rte table';

  slate.rte.wrapTable({
    $tables: $(tableSelectors),
    tableWrapperClass: 'rte__table-wrapper',
  });

  // Target iframes to make them responsive
  var iframeSelectors =
    '.rte iframe[src*="youtube.com/embed"],' +
    '.rte iframe[src*="player.vimeo"]';

  slate.rte.wrapIframe({
    $iframes: $(iframeSelectors),
    iframeWrapperClass: 'rte__video-wrapper'
  });

  // Apply a specific class to the html element for browser support of cookies.
  if (slate.cart.cookiesEnabled()) {
    document.documentElement.className = document.documentElement.className.replace('supports-no-cookies', 'supports-cookies');
  }

  if (window.Shopify && Shopify.StorefrontExpressButtons) {
    Shopify.StorefrontExpressButtons.initialize();
  }

  var Theme = Theme || {};

  Theme.cache = {
    revealTriggers: document.getElementsByClassName('content-reveal__button'),
    $subMenuTriggers: $('.sub-menu-trigger', '#mobileMenu'),
    $cartCountdownCurrency: $('#cartCountdownCurrency'),
    $cartCountdown: $('#cartCountdown')
  };

  var triggerElement = function (elements, target, className) {
    
    var targetEle = null;

    if( elements.length == 0){
      return;
    }

    for ( var i = 0; i < elements.length; i++ ){

      var ele = elements[i];
      
      if( target == null || target == false ){
        targetEle = document.querySelector(ele.dataset.target);
      }else{
        targetEle = document.querySelector(target);
      }
      
      ele.addEventListener('click', function () {
        if ( targetEle.classList.contains(className) ){
          targetEle.classList.remove(className);
        }else{
          targetEle.classList.add(className);
        }
      }, false);
    }
  }

  Theme.cartCountdown = function ( cart ) {

    var theCart = CartJS.cart;

    if( cart != undefined ){
      theCart = cart;
    }

    // Theme.cache.$cartCountdownCurrency
    var limit     = Theme.cache.$cartCountdownCurrency.data('limit'),
        remainder = parseInt(limit) - theCart.total_price;

    if( remainder == limit ){
      Theme.cache.$cartCountdown.addClass('is--ready');
    }else if( remainder < limit && remainder > 0 ){
      Theme.cache.$cartCountdown.removeClass('is--successful');
    }else{
      Theme.cache.$cartCountdown.removeClass('is--successful');
      Theme.cache.$cartCountdown.removeClass('is--ready');
    }

    if( remainder <= 0 ){
      Theme.cache.$cartCountdown.addClass('is--successful');
    }else{
      Theme.cache.$cartCountdownCurrency.text(Shopify.formatMoney(remainder, window.theme.moneyFormat));
    }
  }

  /*
   * Run your theme listeners here.
   * This is done here so that we can use functions from custom plugins.
  */
  Theme.listeners = function (){

    // Cart JS Event
    $(document).on('cart.ready', function(event, cart) {
        // Event handling here.
    });

    // Cart JS Event
    $(document).on('cart.requestStarted', function(event, cart) {
        // Event handling here.
    });

    // Cart JS Event
    $(document).on('cart.requestComplete', function(event, cart) {

        if( window.theme.settings.cart_type == 'drawer' ){
          Drawers.openDrawer('#cartDrawer');
        }

        Theme.cartCountdown(cart);
    });

    Theme.cache.$subMenuTriggers.on('click', function (e) {
      e.preventDefault();
      $(this).parent('.has-sub-menu').toggleClass('is--active');
    });

    $(document).on('click', '.quantity-selector > span', function () {
      var $this   = $(this),
          $input  = $this.parent('.quantity-selector').children('.amount');

      
      if( $this.hasClass('decrease') ){
        var val = parseInt( $input.val() ) - 1;
        
        // If less than 0 - don't do anything
        if( val < 1 ){ return; }

        $this.next("input").val(val);
      }else{
        var val = parseInt( $input.val() ) + 1;
        $this.prev("input").val(val);
      }

      // Check if there is a data attribute added to the input
      if( $input.data('product-id') != "" || $input.data('product-id') != undefined ){

        // If there is, find the corresponding button
        var $button = $('button[data-quick-add="'+$input.data('product-id')+'"]');

        // If there is a button, update the quantity data attribute
        if($button.length > 0){

          $button.attr('data-cart-quantity', $input.val());
        }
      }

    });

    triggerElement(Theme.cache.revealTriggers, false, 'is--active');
  }

  Theme.currencySelector = function(){
    $('.shopify-currency-form select').on('change', function() {
      $(this)
        .parents('form')
        .submit();
    });
  }

  Theme.init = function (){

    // Lets start listening
    Theme.listeners();

    if( window.theme.template != 'index'){

      var elements = $('#shopify-section-header');
      Stickyfill.add(elements);
    }

    Theme.cartCountdown();
    Theme.currencySelector();
  }

  // Initialize Cart JS
  CartJS.init(window.theme.cart, {
    "moneyFormat": window.theme.moneyFormat,
    "moneyWithCurrencyFormat": window.theme.moneyFormatWithCurrency
  });

  // Initialize Cart Wrapper
  CartWrapper.init();

  // intialize Predictive Search
  PredictiveSearch.init();

  // initialize Drawers
  Drawers.init();

  // initialize QuickView
  QuickView.init();

  // initialize Header
  Header.init();

  // initialize Recently Viewed
  RecentlyViewed.init();

  RecentlyViewed.showRecentlyViewed({
    templateId: 'RecentlyViewedTemplate',
    container: 'RecentlyViewed',
    limit: 4
  });

  Theme.init();
  
});
